<template>
  <div v-if="isLoading" class="book-again-loading py-5">
    <v-progress-circular indeterminate color="green" size="30"></v-progress-circular>
  </div>
  <div v-else-if="bookings && bookings.length && !isLoading">
    <v-row no-gutters>
      <v-col class="py-1 d-flex justify-center" cols="3" v-for="(booking, index) in bookings" :key="`latest-booking-${index}`">
        <v-tooltip top :key="`latest-booking-chip-${index}`"
          :color="booking.type == 'daily' ? 'primary' : 'info'">
          <template v-slot:activator="{ on, attrs }">
            <v-chip 
              v-bind="attrs" v-on="on"
              :class="`book-again-chip`" 
              :style="`${ booking.type == 'daily' ? 'background-color: var(--daily-booking-base-light-2); color: var(--daily-booking-base);' : 'background-color: var(--monthly-booking-base-light-2); color: var(--monthly-booking-base);'}`"
              @click="$emit('clickLatestBooking', booking)"
            >
              <v-icon left :style="`${ booking.type == 'daily' ? 'color: var(--daily-booking-base);' : 'color: var(--monthly-booking-base);'}`">mdi-history</v-icon>
              {{ booking.documentId }}
            </v-chip>
          </template>
          <div>
            <!-- <h3 class="text-center">การจองล่าสุด</h3> -->
            <div v-if="booking.documentId"> {{ $t('booking.booking_number') }} : {{ booking.documentId }}</div>
            <div v-if="booking.createdAtFormatTH"> {{ $t('booking.when_booking') }} :
              <v-chip color="gray">
                {{ booking.createdAtFormatTH }}
              </v-chip>
            </div>
            <div v-if="booking.businessName"> {{ $t('contract.business_name') }} : {{ booking.businessName }} </div>
            <div v-if="booking.bookingChannel">{{ $t('booking.booking_channel') }} : {{ booking.bookingChannel.name }} </div>
            <div v-if="booking.stallTypeText"> {{ $t('area.stall_type') }} : {{ booking.stallTypeText }} </div>
            <div v-if="booking.areaNames"> {{ $t('market.market_title') }}({{ booking.countCheckIn }}) :
              <v-chip color="gray">{{ booking.areaBookingNames }}</v-chip>
            </div>
            <div v-if="booking.sumTotalValue > 0"> {{ $t('booking.booking_amount') }} : {{ booking.sumTotalValue | currencySuffixSign }}</div>
            <div v-if="booking.note"> {{ $t('note') }} : {{ booking.note }} </div>
          </div>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
  <div v-else class="book-again-loading py-3">
    <span class="grey--text">{{ $t('booking.no_booking_history') }}</span>
  </div>
</template>

<script>
export default {
  props: {
    bookings: Array,
    isLoading: Boolean,
    isMonthly: {
      default: true,
      type: Boolean
    }
  },
}
</script>

<style lang="scss" scoped>
.book-again-loading {
  display: flex;
  justify-content: center;
}
.book-again-box-in {
  width: calc(100% - 170px);

  .book-again-chip {
    transition: all 200ms;
    &:hover {
      transform: scale(1.1);
      i {
        transform: scale(1.4);
        transition-duration: 300ms;
        transition-timing-function: ease-in-out;
      }
    }
  }
}
.book-again-box {
  padding: 15px 0;
  transition: border-color 500ms;

  
}
</style>